<template>
    <div>
        <template v-if="pageLoading">
            <loading-spinner />
        </template>

        <template v-else>
            <x-container fluid app-width>
                <x-layout align-end mb-2>
                    <x-flex xs8>
                        <h1>Security management</h1>
                    </x-flex>

                    <x-flex xs4 text-xs-right mb-2>
                        <new-and-edit-security :security="newSecurity" action="new" />
                    </x-flex>
                </x-layout>

                <x-divider class="section-divider thick" />

                <x-layout>
                    <x-flex xs12>
                        <x-data-table
                            class="no-row-hover"
                            :headers="headers"
                            :items="securities"
                            item-key="name"
                            :pagination.sync="pagination"
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>{{ props.item.name }}</td>
                                    <td class="text-xs-center">{{ props.item.status | capitalize}}</td>
                                    <td class="text-xs-right">
                                        <new-and-edit-security :security="props.item" action="edit"/>
                                    </td>
                                </tr>
                            </template>
                        </x-data-table>
                    </x-flex>
                </x-layout>

                <x-layout mt-5 mb-5>
                    <x-flex xs12 text-xs-center>
                        <x-pagination circle v-model="pagination.page" :length="pageCount" :total-visible="15" color="grey-1" />
                    </x-flex>
                </x-layout>
            </x-container>
        </template>
    </div>
</template>

<script>
    import NewAndEditSecurity from "~/components/Insurer/NewAndEditSecurity";

    export default {
        name: "InsurerSecurityDashboard",
        components: {NewAndEditSecurity},
        data() {
            return {
                securities: {},
                currentStep: 1,
                pageLoading: true,
                editDialog: false,
                newDialog: false,
                headers: [
                    {
                        text: 'Name',
                        align: 'left',
                        sortable: true,
                        value: 'name',
                        width: '80%'
                    },
                    {
                        text: 'Status',
                        align: 'center',
                        sortable: false,
                        value: 'status'
                    },
                    {
                        text: 'Edit',
                        align: 'right',
                        sortable: false,
                        value: 'edit'
                    },
                ],
                pagination: {
                    totalItems: 0,
                    page: 1,
                    rowsPerPage: 10,
                    sortBy: 'name'
                },
                newSecurity: {
                    name: null,
                    status: 'active'
                }
            }
        },
        computed: {
            pageCount() {
                if (!this.pagination.rowsPerPage || !this.pagination.totalItems) {
                    return 0;
                }

                return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
            },
        },
        watch: {
            pageCount(newPageCount) {
                if (this.pagination.page > newPageCount) {
                    this.pagination.page = 1;
                }
            }
        },
        created() {
            this.fetchData();
        },
        methods: {
            async fetchData() {
                this.securities = (await axios.get(this.$root.api(`insurer/security`))).data.data;

                this.pageLoading = false;
                this.pagination.totalItems  = this.securities.length
            },
        }
    }
</script>

<style lang="scss" scoped>
    :deep(.x-table) {
        margin-top: 36px;
        tr {
            .x-btn {
                opacity: 0;
            }

            &:hover {
                .x-btn {
                    opacity: 1;
                }
            }
        }
    }
</style>
